module.exports = __webpack_public_path__ + "static/media/pspo2.d2f973e8.png";